import {Link} from 'react-router';

import {dataTableColumnT} from '@/lib/types/dataTable.types';
import {retailerT} from '@/lib/types/retailer.types';

/**
 * Render Retailer Table Stats
 * @param {number} totalRetailers
 * @param {number} activeRetailers
 * @param {number} inactiveRetailers
 * @returns {object[]}
 */
export const renderRetailerTableStats = (
  totalRetailers: number | null | undefined,
  activeRetailers: number | null | undefined,
  inactiveRetailers: number | null | undefined
) => [
  {
    title: 'Total Retailers',
    value: totalRetailers,
    subtitle: 'This Month',
    change: 1.03,
    icon: 'ri-store-line',
    color: 'primary',
    cardClass: 'Retailers-main-card primary',
  },
  {
    title: 'Active Retailers',
    value: activeRetailers,
    subtitle: 'This Month',
    change: 0.36,
    icon: 'ri-check-line',
    color: 'secondary',
    cardClass: 'Retailers-main-card secondary',
  },
  {
    title: 'Inactive Retailers',
    value: inactiveRetailers,
    subtitle: 'This Month',
    change: -1.28,
    icon: 'ri-close-line',
    color: 'warning',
    cardClass: 'Retailers-main-card warning',
  },
];

/**
 * Retailer Table Columns
 * @returns {dataTableColumnT<retailerT>[]}
 */
export const retailerColumns: dataTableColumnT<'Retailer'>[] = [
  {header: 'Retailer ID', field: 'retailer_id'},
  {
    header: 'Status',
    field: 'date_removed',
    render: (retailer: retailerT) => (
      <span className={`badge bg-${!retailer.date_removed ? 'success' : 'danger'} text-white`}>
        {!retailer.date_removed ? 'Active' : 'Inactive'}
      </span>
    ),
  },
  {
    header: 'Location Name',
    field: 'retailer_name',
    render: (retailer: retailerT) => (
      <Link className="text-primary underline" to={`/retailers/${retailer.retailer_id}`}>
        {retailer.retailer_name}
      </Link>
    ),
  },
  {header: 'Address', field: 'retailer_address'},
  {header: 'City', field: 'retailer_city'},
  {header: 'State', field: 'retailer_state'},
  {header: 'Postal Code', field: 'retailer_postal_code'},
  {header: 'License Number', field: 'retailer_license_number'},
  {header: 'Created', field: 'date_created'},
  {header: 'Modified', field: 'date_modified'},
];
